<template>
  <mdb-container>
    <EditAISearchPrompts />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditAISearchPrompts from "@/components/EditAISearchPrompts.vue";

export default {
  name: "AISearchPrompts",
  components: { mdbContainer, EditAISearchPrompts },
};
</script>